import { useEffect, useState } from 'react';
import { trackPageView } from '@medflex/utils/Tracking';
import useReactRouterContext from './useReactRouterContext.js';

const useMatomoTracker = () => {
  const { history } = useReactRouterContext();
  const [currentUrl, setCurrentUrl] = useState(null);

  useEffect(
    () =>
      history.listen(({ pathname, search }) => {
        setCurrentUrl(`${pathname}${search}`);
      }),
    [],
  );

  useEffect(() => {
    trackPageView();
  }, [currentUrl]);
};

export default useMatomoTracker;
